<h2>{{ data.headerText }}</h2>
<mat-divider></mat-divider>
<h3 [innerHtml]="data.message"></h3>
<div mat-dialog-actions align="end">
  @if (data.showCancelButton !== false) {
  <button mat-button (click)="cancel()" class="mm-bg-accent mm-text-white">Cancel</button>
  }
  <button
    mat-button
    (click)="confirm()"
    cdkFocusInitial
    class="mm-text-white contains-spinner"
    [ngClass]="data.danger ? 'dialog-confirm-danger' : 'mm-bg-primary'"
  >
    {{ data.confirmButtonText || 'Confirm' }}
  </button>
</div>
